import { useEffect, useRef, useState } from "react";
import axios from "../../../../../axios";
import ThreeDotPostPopup from "./ThreeDot_Post_Popup";
import moment from "moment";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import CreatePostFirst from "../../Create_Post_screen/CreatePostFirst";
import { IP } from "../../../../../internalServer";
import { Popup } from "semantic-ui-react";
import assets from "../../../../../assets/assets";
import LikePopUp from "./popUpScreen";
import FeedDetail from "../../Feed_Detail/FeedDetail";
import CloseIcon from "@mui/icons-material/Close";
import {
  FacebookShareButton,
  WhatsappShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  TelegramShareButton,
  FacebookIcon,
  WhatsappIcon,
  TwitterIcon,
  LinkedinIcon,
  TelegramIcon,
} from "react-share";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
} from "@mui/material";

const PostImage = ({
  post,
  community,
  members,
  communityId,
  setIsEdited,
  refetch,
  isEdited,
  commentLength,
  setIsPostCreated1,
  isAdminOrTeacherAdmin,
  TotalCommuPost,
}) => {
  const popupRef = useRef(null);
  const [replycpy, setreplyCnt] = useState(post);
  const [postThreedot, setPostThreedot] = useState(false);
  const [postLikeClick, setPostLikeClick] = useState(false);
  const [postLlikeCount, setPostLlikeCount] = useState(post?.like_count);
  const teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [isOpen, setIsOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(1);
  const [postEdit, setPostEdit] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [postId, setPostId] = useState("");
  const [openSocialSharepopup, setOpenSocialSharepopup] = useState(false);
  const isDisabled = true; // or your condition

  // const [members, setMembers] = useState([]);
  const handleSlideChange = (current) => {
    setCurrentSlide(current + 1);
  };

  const [likedRes, setLikedRes] = useState(null);
  var settings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    afterChange: handleSlideChange,
    arrows: true,
  };
  useEffect(() => {
    if (post) {
      let isLiked = post?.likes?.some((like) => like.userId === teacher_id);
      setPostLikeClick(isLiked);
    }
  }, [post, teacher_id]);

  const handelPostLike = async (e) => {
    try {
      let res = await axios.put(`/api/v1/community/post/like/${post.id}`, {
        user_id: teacher_id,
      });
      setPostLlikeCount(
        postLikeClick ? postLlikeCount - 1 : postLlikeCount + 1,
      );
      setPostLikeClick(!postLikeClick);
      setLikedRes(res.data.data);
    } catch (error) {
      console.log(error);
    }
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    // Adding 5 hours and 30 minutes to the date
    dateObj.setUTCHours(dateObj.getUTCHours() + 5);
    dateObj.setUTCMinutes(dateObj.getUTCMinutes() + 30);

    const day = dateObj.getUTCDate();
    const month = dateObj.getUTCMonth() + 1;
    const year = dateObj.getUTCFullYear();
    const hours = dateObj.getUTCHours();
    const minutes = dateObj.getUTCMinutes();
    const seconds = dateObj.getUTCSeconds();

    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (popupRef.current && !popupRef.current.contains(event.target)) {
      setPostThreedot(false);
    }
  };
  useEffect(() => {
    if (likedRes) {
      setreplyCnt((prevReply) => ({ ...prevReply, ...likedRes }));
    }
  }, [likedRes]);

  const handleClick = () => {
    // If popup already open for same post, block click
    if (openPopup && postId === post?.id) return;

    // Allow new popup
    setOpenPopup(true);
    setPostId(post?.id);
  };

  const shareUrl = "https://breathe4school.com/";
  const title = "checkout this website";

  return post && post?.community_id ? (
    <>
      <div
        className="post_img_container w-100 mt-4 rounded-4"
        style={{ backgroundColor: "white" }}
      >
        <div
          className=" w-100 d-flex gap-2 flex-row "
          style={{ padding: "5px 10px" }}
        >
          {/* Image */}
          <div className="gap-2 mt-1 mb-3 d-flex ">
            {post?.user_id?.user_type === "Teacher" ? (
              <img
                src={
                  post?.user_id?.profile_picture
                    ? IP + post?.user_id?.profile_picture.replace(/^\./, "")
                    : post?.user_id?.gender === "M"
                      ? "/images/Teacher_Male.jpg"
                      : post?.user_id?.gender === "F"
                        ? "/images/Teacher_Female.png"
                        : "/images/default-profile.png"
                }
                alt="icon"
                className="profilePicImg"
                style={{ width: "60px", height: "60px", borderRadius: "20%" }}
                onError={(e) => {
                  // This function will run if the image fails to load
                  if (post?.user_id?.gender === "M") {
                    e.target.src = "/images/Teacher_Male.jpg";
                  } else if (post?.user_id?.gender === "F") {
                    e.target.src = "/images/Teacher_Female.png";
                  } else {
                    e.target.src = "/images/default-profile.png";
                  }
                }}
              />
            ) : (
              <img
                src={
                  post?.user_id?.profile_picture
                    ? IP + post?.user_id?.profile_picture.replace(/^\./, "")
                    : post?.user_id?.gender === "M"
                      ? post?.user_id?.avatar_profile
                        ? "/images/Boys/" +
                        post?.user_id?.avatar_profile +
                        ".webp"
                        : "/images/Student_boy_pic.png"
                      : post?.user_id?.gender === "F"
                        ? post?.user_id?.avatar_profile
                          ? "/images/Girls/" +
                          post?.user_id?.avatar_profile +
                          ".webp"
                          : "/images/Student_girl_pic.png"
                        : "/images/default image.png"
                }
                alt="icon"
                className="prifilePicImg"
                key={post?.user_id?.avatar_profile}
                style={{ width: "60px", height: "60px", borderRadius: "20%" }}
                onError={(e) => {
                  if (post?.user_id?.gender === "M") {
                    // console.log("insie if")
                    e.target.src = post?.user_id?.avatar_profile
                      ? "/images/Boys/" +
                      post?.user_id?.avatar_profile +
                      ".webp"
                      : "/images/Student_boy_pic.png";
                  } else if (post?.user_id?.gender === "F") {
                    e.target.src = post?.user_id?.avatar_profile
                      ? "/images/Girls/" +
                      post?.user_id?.avatar_profile +
                      ".webp"
                      : "/images/Student_girl_pic.png";
                  } else {
                    e.target.src = "/images/default image.png";
                  }
                }}
              />
            )}
          </div>
          {/* full post */}
          <div
            className="p-2 rounded-3 w-100"
            style={{ border: "2px solid #E5E5E5", overflow: "hidden" }}
          >
            <div className="w-100">
              <div className=" d-flex justify-content-between px-4 py-1 ">
                <div
                  onClick={handleClick}
                  style={{
                    cursor:
                      openPopup && postId === post?.id ? "default" : "pointer",
                    pointerEvents:
                      openPopup && postId === post?.id ? "none" : "auto",
                    opacity: openPopup && postId === post?.id ? 0.6 : 1,
                  }}
                >
                  <div className="d-flex align-items-center">
                    {post?.user_id?.user_type === "Teacher" && (
                      <img
                        className="mr-2"
                        src="/images/teacher_icon.svg"
                        alt=""
                      />
                    )}
                    <span className="request_channel_name mr-2">
                      {post?.user_id?.name}
                    </span>
                    {post?.user_id?.user_type === "Student" && (
                      <span className="request_channel_name mr-2">
                        &nbsp;
                        {post?.user_id?.standard?.name} -
                        {post?.user_id?.section?.name}
                      </span>
                    )}
                    <div className="m-0 p-0 post_tags_list d-flex align-items-center">
                      {post?.tags.length > 0 &&
                        post?.tags.map((tag) => (
                          <span className="related_postName mx-1  px-2 py-1">
                            {tag}
                          </span>
                        ))}
                    </div>
                  </div>
                  <div className=" request_created_by">
                    {post?.community_id?.community_name}
                  </div>
                  <small className=" request_created_by">
                    {moment(timeHelper(post?.created_at)).calendar({
                      sameDay: "[Today] hh:mm a",
                      lastDay: "[Yesterday] hh:mm a",
                      lastWeek: "DD MMM YYYY hh:mm a",
                      sameElse: "DD MMM YYYY hh:mm a",
                    })}
                  </small>
                </div>
                {/* this comment will hide the delete tag from gloabal community page */}
                {/* {TotalCommuPost === "TotalCommuPost" ? null : ( */}
                <div style={{ position: "relative" }}>
                  {!post?.isDeleted && post?.user_id?.id === teacher_id ? (
                    <>
                      <img
                        className="Post_HR_threedot"
                        src="/images/three dot hr.svg"
                        alt=""
                        style={{ cursor: "pointer" }}
                        onClick={() => setPostThreedot(!postThreedot)}
                      />

                      {postThreedot && (
                        <div
                          ref={popupRef}
                          style={{
                            position: "absolute",
                            top: "28px",
                            right: "0",
                            zIndex: 999,
                          }}
                        >
                          <ThreeDotPostPopup
                            setPostThreedot={setPostThreedot}
                            setPostEdit={setPostEdit}
                            post_id={post?.id}
                            communityId={post?.community_id?.id}
                            members={members}
                            post={post}
                            refetch1={refetch}
                          />
                        </div>
                      )}
                    </>
                  ) : post?.isDeleted ? (
                    <div className="delte">*Deleted</div>
                  ) : null}
                </div>
                {/* )} */}
              </div>
            </div>
            <div className="mb-2 px-4 py-3 w-full">
              <div
                onClick={handleClick}
                style={{
                  cursor:
                    openPopup && postId === post?.id ? "default" : "pointer",
                  pointerEvents:
                    openPopup && postId === post?.id ? "none" : "auto",
                  opacity: openPopup && postId === post?.id ? 0.6 : 1,
                }}
              // to={`/feedDetail`}
              // className="link"
              // state={{ post_id: post?.id }}
              >
                <span className="post_description poppins-semibold">
                  {post?.description}
                </span>
              </div>
            </div>
            {post?.post_image?.length > 0 && (
              <div
                style={{ width: "800px" }}
                className="col-12 mt-3 mb-4 p-0 request_post_image_box"
              >
                {post?.post_image?.length > 0 && (
                  <div className="slider_container">
                    <Slider {...settings}>
                      {post?.post_image?.length > 0 &&
                        post?.post_image?.map((item, idx) => {
                          return (
                            <div
                              onClick={() => {
                                if (openPopup && postId === post?.id) return;
                                setOpenPopup(true);
                                setPostId(post?.id);
                              }}
                              style={{
                                cursor: openPopup ? "default" : "pointer",
                              }}
                            >
                              <img
                                key={idx}
                                src={`${IP + item}`}
                                className="request_post_image"
                                alt="img"
                                onError={(e) => {
                                  e.target.src = "/images/no-image5.png";
                                }}
                              />
                            </div>
                          );
                        })}
                    </Slider>
                    {post?.post_image?.length > 1 && (
                      <span className="post_image_count d-flex align-items-center justify-content-center">
                        {currentSlide}/{post?.post_image?.length}
                      </span>
                    )}
                  </div>
                )}
              </div>
            )}

            <div
              className="d-flex justify-content-between align-items-center pb-2 border-bottom border-4"
              style={{ cursor: "pointer" }}
            >
              <small className="poppins-semibold ms-4">
                {" "}
                {postLlikeCount}{" "}
                <Popup
                  on={"click"}
                  open={isOpen}
                  onOpen={() => {
                    if (postLlikeCount > 0) setIsOpen(true);
                  }}
                  onClose={() => setIsOpen(false)}
                  trigger={
                    <span>{postLlikeCount === 0 ? "Like" : "Likes"}</span>
                  }
                  position="bottom right"
                  content={
                    <LikePopUp
                      post={replycpy}
                      likedRes={likedRes || {}}
                      setIsOpen={setIsOpen}
                      isOpen={isOpen}
                    />
                  }
                />
              </small>
              <div
                className="me-4"
                onClick={handleClick}
                style={{
                  cursor:
                    openPopup && postId === post?.id ? "default" : "pointer",
                  pointerEvents:
                    openPopup && postId === post?.id ? "none" : "auto",
                  opacity: openPopup && postId === post?.id ? 0.6 : 1,
                }}
              >
                <small className="poppins-semibold ">
                  {commentLength
                    ? post?.comment_count + commentLength
                    : post?.comment_count}
                </small>
                <small className="poppins-semibold"> Comments</small>
              </div>
            </div>

            <div className=" px-2 mt-2 mb-3  d-flex gap-6 like_comment_shear ">
              <div className="like_comment_shear_style d-flex align-items-center ms-4 fs-6 gap-2">
                {!postLikeClick ? (
                  <img
                    src={assets.LikeIcon}
                    className="like_shear_img"
                    width={20}
                    height={20}
                    onClick={post?.isDeleted ? () => { } : handelPostLike}
                    alt=""
                  />
                ) : (
                  <img
                    src={assets.BlueLikeIcon}
                    className="like_shear_img"
                    width={20}
                    height={20}
                    onClick={handelPostLike}
                    alt=""
                  />
                )}
                <small>Like</small>
              </div>
              <div
                onClick={handleClick}
                style={{
                  cursor:
                    openPopup && postId === post?.id ? "default" : "pointer",
                  pointerEvents:
                    openPopup && postId === post?.id ? "none" : "auto",
                  opacity: openPopup && postId === post?.id ? 0.6 : 1,
                }}
              >
                <div className="like_comment_shear_style d-flex align-items-center gap-1 fs-6 ms-4">
                  <img
                    src={assets.commentIcon}
                    className="like_shear_img mr-1"
                    width={20}
                    height={20}
                    alt=""
                  />
                  <small>Comment</small>
                </div>
              </div>

              <div
                className={`share_style d-flex align-items-center gap-1 fs-6 ms-4 ${isDisabled ? "disabled-share" : ""
                  }`}
                onClick={() => {
                  if (!isDisabled) {
                    setOpenSocialSharepopup(true);
                  }
                }}
              >
                <img
                  src="/images/shear.svg"
                  className="share_img"
                  alt=""
                />
                <span> Share</span>
              </div>
            </div>
          </div>
        </div>
        {postEdit && (
          <CreatePostFirst
            editingMode={true}
            post={post}
            setClickPost={setPostEdit}
            clickPost={postEdit}
            refetch1={refetch}
            setIsPostCreated2={setIsPostCreated1}
            setIsEdited={setIsEdited}
          />
        )}
      </div>

      {openPopup && (
        <div
          style={{
            position: "absolute",
            top: "0",
            left: "0",
            right: "0",
            bottom: "0",
            height: "100vh",
            width: "100vw",
            backgroundColor: " rgba(0, 0, 0, 0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: "556",
          }}
        >
          <div
            className=" p-2 successful_preview_container shadow position-relative"
            style={{
              width: "60vw",
              height: "90vh",
              display: "flex",
              justifyContent: "start",
              alignItems: "start",
            }}
          >
            <div className="h-100 w-100">
              <div
                className="p-3"
                style={{
                  width: "100%",
                }}
              >
                <div
                  className="d-flex align-items-center justify-content-between"
                  onClick={(e) => {
                    setOpenPopup(false);
                    setPostId("");
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <h6 className="poppins-semibold ml-2 text-primary">POST</h6>
                  <img
                    src={assets.closeIcon}
                    alt=""
                    style={{ width: "28px", height: "28px" }}
                    onClick={(e) => {
                      setOpenPopup(false);
                      setPostId("");
                    }}
                  />
                </div>
                <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                  <FeedDetail
                    setOpenPopup={setOpenPopup}
                    postId={postId}
                    setIsEdited={setIsEdited}
                    isEdited={isEdited}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Dialog
        open={openSocialSharepopup}
        onClose={() => setOpenSocialSharepopup(false)}
      >
        <DialogTitle
          sx={{
            m: 0,
            p: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          Share this post
          <IconButton
            onClick={() => setOpenSocialSharepopup(false)}
            size="small"
            sx={{ ml: 2 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Grid container spacing={2} justifyContent="center">
            <Grid item>
              <FacebookShareButton url={shareUrl} quote={title}>
                <FacebookIcon size={48} round />
              </FacebookShareButton>
            </Grid>
            <Grid item>
              <WhatsappShareButton url={shareUrl} title={title}>
                <WhatsappIcon size={48} round />
              </WhatsappShareButton>
            </Grid>
            <Grid item>
              <TwitterShareButton url={shareUrl} title={title}>
                <TwitterIcon size={48} round />
              </TwitterShareButton>
            </Grid>
            <Grid item>
              <LinkedinShareButton url={shareUrl}>
                <LinkedinIcon size={48} round />
              </LinkedinShareButton>
            </Grid>
            <Grid item>
              <TelegramShareButton url={shareUrl} title={title}>
                <TelegramIcon size={48} round />
              </TelegramShareButton>
            </Grid>
          </Grid>
        </DialogContent>
      </Dialog>
    </>
  ) : (
    <>{/* <img className="Loader" src="/gif/Loader.gif" alt="" /> */}</>
  );
};

export default PostImage;
